import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=8cb865aa&"
import script from "./Videos.vue?vue&type=script&lang=ts&"
export * from "./Videos.vue?vue&type=script&lang=ts&"
import style0 from "./Videos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports